document.addEventListener('DOMContentLoaded', function () {
  const sliderWrappers = document.querySelectorAll('.slider-wrapper-image-comparison');

  sliderWrappers.forEach((wrapper) => {
    const slider = wrapper.querySelector('.image-comparison-slider-rs');
    const beforeLabel = wrapper.querySelector('.before-label');
    const afterLabel = wrapper.querySelector('.after-label');
    const contentArea = wrapper.querySelector('.content-area-image-comparison');

    if (!slider || !beforeLabel || !afterLabel || !contentArea) {
      console.warn('Missing required elements in this slider block:', wrapper);
      return; // Skip this block if essential elements are missing
    }

    // Event listener for slider movement
    slider.addEventListener('input', function (e) {
      const position = e.target.value;
      contentArea.style.setProperty('--position', `${position}%`);

      beforeLabel.style.display = position <= 5 ? 'none' : 'block';
      afterLabel.style.display = position >= 95 ? 'none' : 'block';
    });

    // Initialize label visibility on page load
    const initialPosition = slider.value;
    beforeLabel.style.display = initialPosition <= 5 ? 'none' : 'block';
    afterLabel.style.display = initialPosition >= 95 ? 'none' : 'block';
  });
});